/**
 * WordPress dependencies
 */
import { store, getContext } from '@wordpress/interactivity';

store( 'multiple-choice-quiz', {
	actions: {
		updateValue: ( event ) => {
            const context = getContext();
            // This 'context' is unique to the specific child block clicked
            context.selectedOption = event.target.value;
            
            console.log( `Updating block ${context.id} to ${context.selectedOption}` );
        },
        checkAnswer() {
			const context = getContext();
			if (context.selectedOption === context.theCorrectAnswer) {
				context.isCorrect = true;
				context.gradeMessage = 'Correct!';
				context.showCheck = true;
				context.showX = false;
			} else {
				context.isCorrect = false;
				context.gradeMessage = `Incorrect: The correct answer is ${context.theCorrectAnswer}`;
				context.showX = true;
				context.showCheck = false;
			};
		}
	},
	callbacks: {
		checkWrongMessage: () => {
			const context = getContext();
			if ( context.selectedOption === 'initial-value') {
				context.hideWrongMessage = true;
			} else { context.hideWrongMessage = false; }
		}
	}
} );